import "../../assets/stylesheets/application.scss";
import * as Tracking from "../src/common/tracking";
import "@hotwired/turbo-rails";

import * as SvelteImporter from "../src/svelteImporter.js";
import * as CustomSvelteImporter from "../src/common/svelteImporter.js";

import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";

SvelteImporter.createEventListeners(
  "common",
  CustomSvelteImporter.customRequire
);

window.track = Tracking.track;

// deal with iOS (and maybe other mobile devices) url bar
const appHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

window.addEventListener("resize", appHeight);
appHeight();
